import Clock from "./Clock";

export default function UserBar() {
	return (
		<div className="userBar">
			<Clock />
			<div>
				Welcome!
			</div>
		</div>
	)
}